export const AxleFormName = 'axles';

export type AxlesData = {
  [AxleFormName]?: AxleData[];
};

export const AxleFieldNames = {
  AxleId: 'axleId',
  AxleWeight: 'axleWeight',
  AxleWidth: 'axleWidth',
  AxleSpacing: 'axleSpacing',
  TireCount: 'tireCount',
  TireRating: 'tireRating',
  AxleCapacity: 'axleCapacity',
  AxleType: 'axleType',
  SuspensionType: 'suspensionType',
  AxleGroup: 'axleGroup',
  IsSteeringAxle: 'isSteeringAxle',
  TireSize: 'tireSize',
} as const;

export type AxleData = {
  [AxleFieldNames.AxleId]?: string;
  [AxleFieldNames.AxleWeight]?: number;
  [AxleFieldNames.AxleWidth]?: number | string;
  [AxleFieldNames.AxleSpacing]?: number | string;
  [AxleFieldNames.TireCount]?: number;
  [AxleFieldNames.TireRating]?: number;
  [AxleFieldNames.AxleCapacity]?: number;
  [AxleFieldNames.AxleType]?: string;
  [AxleFieldNames.SuspensionType]?: string;
  [AxleFieldNames.AxleGroup]?: string;
  [AxleFieldNames.IsSteeringAxle]?: boolean;
  [AxleFieldNames.TireSize]?: string;
};

export const AxleFieldValues: string[] = Object.values(AxleFieldNames);
